import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import logo from '@/images/stepup-logo-white.svg'
import Img from '@/lib/Img'
import FooterNav from './FooterNav'
import NewsletterSignUp from './NewsletterSignUp'
import FollowUs from './FollowUs'
import FooterBottom from './FooterBottom'

const Footer = () => {
	const { footer } = useStaticQuery(query)

	return (
		<footer id="footer" className="bg-spirited-gold z-10 relative">
			<div className="max-w-screen-xl mx-auto py-12 px-4 grid gap-8">
				<div className="flex <md:flex-col items-center gap-4">
					<figure className="flex-grow text-white">
						<Link className="inline-block" to="/">
							<img className="max-h-[40px]" src={logo} alt="Step Up" />
						</Link>
					</figure>

					<figure className="flex gap-y-4 gap-x-12 items-center">
						{footer?.sponsors?.map((sponsor, key) => (
							<Img {...sponsor} key={key} />
						))}
					</figure>
				</div>

				<FooterNav nav={footer.nav} />

				<div className="grid md:grid-cols-2 gap-8">
					<NewsletterSignUp />
					<FollowUs />
				</div>

				<FooterBottom />
			</div>
		</footer>
	)
}

export default Footer

export const query = graphql`query Footer {
	footer: sanityFooter {
		sponsors {
			image { asset { gatsbyImageData(placeholder: NONE, height: 80) } }
			alt
		}
		nav { ...linkGroup }
	}
}`
